import { HttpService } from "./http";
import { API_BASE_URL } from "../constants/API";

const Endpoint = {
  fetchPreOrderDetail: `${API_BASE_URL}/preOrders`,
  fetchPreOrderIds: `${API_BASE_URL}/preOrders/ids`,
  fetchFindAllPendingERP: `${API_BASE_URL}/preOrders/pendingERP`,
  fetchGenerateAllPendingERPErrors: `${API_BASE_URL}/preOrders/generate-erp-errors`,
  approvePreOrder: `${API_BASE_URL}/preOrders`,
  refusePreOrder: `${API_BASE_URL}/preOrders`,
  cancelPreOrder: `${API_BASE_URL}/preOrders`,
};

export class PreOrderService {
  static getDefaultRequest = () => ({
    skip: 0,
    take: 100,
  });

  static async fetchPreOrderDetail(data) {
    const request = PreOrderService.getDefaultRequest();

    request.skip = data.skip;
    request.take = data.take;
    request.filters = data.filters;
    const response = await HttpService.post(
      `${Endpoint.fetchPreOrderDetail}/${data.preOrderId}`,
      request
    );
    return response;
  }

  static async fetchFindAllPendingERP() {
    const response = await HttpService.get(
      `${Endpoint.fetchFindAllPendingERP}`
    );
    return response;
  }

  static async fetchTryAgainGenerateERPFile(preOrderId) {
    const response = await HttpService.post(
      `${Endpoint.fetchPreOrderDetail}/${preOrderId}/erp`
    );
    return response;
  }

  static async fetchGenerateAllPendingERPErrors() {
    const response = await HttpService.post(
      `${Endpoint.fetchGenerateAllPendingERPErrors}`
    );
    return response;
  }

  static async approvePreOrder(preOrderId) {
    const response = await HttpService.patch(
      `${Endpoint.approvePreOrder}/${preOrderId}/approve`
    );
    return response;
  }

  static async refusePreOrder(preOrderId) {
    const response = await HttpService.delete(
      `${Endpoint.refusePreOrder}/${preOrderId}/refuse`
    );
    return response;
  }

  static async cancelPreOrder(preOrderId) {
    const response = await HttpService.patch(
      `${Endpoint.cancelPreOrder}/${preOrderId}/cancel`
    );
    return response;
  }

  static async fetchPreOrderIds({ take = 10, lastId, search } = {}) {
    const params = { take };
    if (lastId != null) params.lastId = lastId;
    if (search != null && search !== '') params.search = search;
    const response = await HttpService.get(Endpoint.fetchPreOrderIds, params);
    return response;
  }
}

export default PreOrderService;
